import { adaptHtml, adaptMedia, adaptSelector } from 'adapters/base';

export const adaptGalleryCarousel = (component, language) => {
  try {
    return {
      id: component.path,
      controlId: component.controlId,
      type: 'galleryCarousel',
      fields: {
        gallery: __adaptGalleryCarousel(component.contentFields[0], 'gallery', language),
        carouselType: adaptSelector(component.contentFields[0], 'carouselType', language, 'carousel'),
        marginBottom: adaptSelector(component.contentFields[0], 'margin_bottom', language, 'margin__bottom__160'),
        backgroundColor: adaptHtml(component.contentFields[0], 'background_color', language, 'transparent'),
      },
    };
  } catch (e) {
    console.error('Error adapting GalleryCarousel component', e);
    return null;
  }
};

export const __adaptGalleryCarousel = (contentFields, path, language) => {
  const currentCF = contentFields ? contentFields.find((contentField) => contentField.path === path) : null;
  if (!currentCF) return [];

  return currentCF.contentFields?.map((item) => {
    return {
      media: adaptMedia(item, 'gallery_image', language),
      caption: adaptHtml(item, 'gallery_caption', language),
      file: adaptMedia(item, 'file-to-download', language),
    };
  });
};
